// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__4m2lL","overlay":"styles_overlay__U6RCO","link":"styles_link__H_YvO","headline":"styles_headline__GCouq","subheadline":"styles_subheadline__k9jmt"};